import {PurchaseRequest} from '../../../../models/PurchaseRequest.js';

/**
 * Inputs shared by every disable rule.
 * @typedef {Object} EditabilityContext
 * @property {boolean} prLocked
 * @property {boolean} userHasAccessToProperties
 * @property {string|null} tab
 * @property {boolean} submittedTab
 * @property {boolean} pendingSbTab
 * @property {string|null} source
 * @property {string|null} sourceToDisplay
 * @property {?{label: string, value: string}} wayOfBuying
 * @property {?Object} material
 */

/**
 * Reads the current way of buying from a request-store snapshot.
 * @param {Object} store
 * @return {?{label: string, value: string}}
 */
function readWayOfBuying(store) {
    const wayOfBuying = store?.wayOfBuying;
    if (!wayOfBuying) {
        return null;
    }
    return wayOfBuying.currentValue ?? null;
}

/**
 * Builds the editability context from the request store, the current tab, and an optional material.
 * @param {{store?: Object, tab?: string, material?: Object}} [params]
 * @return {EditabilityContext}
 */
export function buildEditabilityContext({store = {}, tab, material} = {}) {
    const resolvedTab = tab ?? null;
    return {
        prLocked: Boolean(store.prLocked),
        userHasAccessToProperties: Boolean(store.userHasAccessToProperties),
        tab: resolvedTab,
        submittedTab: resolvedTab === PurchaseRequest.tab.submitted,
        pendingSbTab: resolvedTab === PurchaseRequest.tab.pendingSb,
        source: store.source ?? null,
        sourceToDisplay: store.sourceToDisplay ?? null,
        wayOfBuying: readWayOfBuying(store),
        material: material ?? null,
    };
}
